import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import { SimpleDialogProps } from '../Commonprops';
import React, { ReactElement, useEffect, useState } from 'react';
import { farmService } from '../../Layout/ManageFarms/FarmService';
import { CardWrapper } from '../../Layout/Common/CommonComponents';
import { List as VirtualizedList, RowComponentProps } from 'react-window';
import { showToast } from '../../../lib/toast';

interface SkuRowExtraProps {
  plans: string[];
  onItemClick: (value: string) => void;
}

type SkuRowProps = RowComponentProps & SkuRowExtraProps;

const SkuRow = ({
  index,
  style,
  plans,
  onItemClick,
}: SkuRowProps): ReactElement => (
  <ListItem style={style} key={plans[index + 1]}>
    <ListItemButton onClick={() => onItemClick(plans[index + 1])}>
      <ListItemText primary={plans[index + 1]} />
    </ListItemButton>
  </ListItem>
);

export function AppserviceSkuDialog(props: Readonly<SimpleDialogProps>) {
  const { onClose, selectedValue, open } = props;

  const [plans, setPlans] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    initializeSkusList();
  }, []);

  const handleClose = () => {
    onClose(selectedValue);
  };

  const initializeSkusList = async () => {
    setLoading(true);
    await farmService
      .getWebAppSkus()
      .then((response) => {
        setPlans(response);
      })
      .catch((error) => {
        showToast({
          type: 'error',
          title: `Failed to load app service Skus: ${error.message}`,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleListItemClick = (value: string) => {
    onClose(value);
  };

  return (
    <Dialog
      disableEscapeKeyDown
      open={open}
      fullWidth
      maxWidth="lg"
      onClose={handleClose}
    >
      <DialogTitle>Appservice Skus</DialogTitle>
      <Divider sx={{ mt: 2 }} />
      <DialogContent>
        <CardWrapper>
          {loading ? (
            <CircularProgress sx={{ display: 'block', margin: 'auto' }} />
          ) : (
            <VirtualizedList
              style={{ height: 400 }}
              rowHeight={50}
              rowCount={plans.length - 1}
              rowComponent={SkuRow}
              rowProps={{ plans, onItemClick: handleListItemClick }}
            />
          )}
        </CardWrapper>
      </DialogContent>
    </Dialog>
  );
}
